'use strict';

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var Types = require('./types');

var internals = {
  mismatched: null
};

module.exports = function (obj, ref, options) {
  options = Object.assign({
    prototype: true
  }, options);
  return !!internals.isDeepEqual(obj, ref, options, []);
};

internals.isDeepEqual = function (obj, ref, options, seen) {
  if (obj === ref) {
    // Copied from Deep-eql, copyright(c) 2013 Jake Luer, jake@alogicalparadox.com, MIT Licensed, https://github.com/chaijs/deep-eql
    return obj !== 0 || 1 / obj === 1 / ref;
  }

  var type = typeof obj;

  if (type !== typeof ref) {
    return false;
  }

  if (obj === null || ref === null) {
    return false;
  }

  if (type === 'function') {
    if (!options.deepFunction || obj.toString() !== ref.toString()) {
      return false;
    } // Continue as object

  } else if (type !== 'object') {
    return obj !== obj && ref !== ref; // NaN
  }

  var instanceType = internals.getSharedType(obj, ref, !!options.prototype);

  switch (instanceType) {
    case Types.buffer:
      return Buffer && Buffer.prototype.equals.call(obj, ref);
    // $lab:coverage:ignore$

    case Types.promise:
      return obj === ref;

    case Types.regex:
      return obj.toString() === ref.toString();

    case internals.mismatched:
      return false;
  }

  for (var i = seen.length - 1; i >= 0; --i) {
    if (seen[i].isSame(obj, ref)) {
      return true; // If previous comparison failed, it would have stopped execution
    }
  }

  seen.push(new internals.SeenEntry(obj, ref));

  try {
    return !!internals.isDeepEqualObj(instanceType, obj, ref, options, seen);
  } finally {
    seen.pop();
  }
};

internals.getSharedType = function (obj, ref, checkPrototype) {
  if (checkPrototype) {
    if (Object.getPrototypeOf(obj) !== Object.getPrototypeOf(ref)) {
      return internals.mismatched;
    }

    return Types.getInternalProto(obj);
  }

  var type = Types.getInternalProto(obj);

  if (type !== Types.getInternalProto(ref)) {
    return internals.mismatched;
  }

  return type;
};

internals.valueOf = function (obj) {
  var objValueOf = obj.valueOf;

  if (objValueOf === undefined) {
    return obj;
  }

  try {
    return objValueOf.call(obj);
  } catch (err) {
    return err;
  }
};

internals.hasOwnEnumerableProperty = function (obj, key) {
  return Object.prototype.propertyIsEnumerable.call(obj, key);
};

internals.isSetSimpleEqual = function (obj, ref) {
  var _iterator = _createForOfIteratorHelper(obj),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;

      if (!ref.has(entry)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

internals.isDeepEqualObj = function (instanceType, obj, ref, options, seen) {
  var isDeepEqual = internals.isDeepEqual,
      valueOf = internals.valueOf,
      hasOwnEnumerableProperty = internals.hasOwnEnumerableProperty;
  var keys = Object.keys,
      getOwnPropertySymbols = Object.getOwnPropertySymbols;

  if (instanceType === Types.array) {
    if (options.part) {
      // Check if any index match any other index
      var _iterator2 = _createForOfIteratorHelper(obj),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var objValue = _step2.value;

          var _iterator3 = _createForOfIteratorHelper(ref),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var refValue = _step3.value;

              if (isDeepEqual(objValue, refValue, options, seen)) {
                return true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      if (obj.length !== ref.length) {
        return false;
      }

      for (var i = 0; i < obj.length; ++i) {
        if (!isDeepEqual(obj[i], ref[i], options, seen)) {
          return false;
        }
      }

      return true;
    }
  } else if (instanceType === Types.set) {
    if (obj.size !== ref.size) {
      return false;
    }

    if (!internals.isSetSimpleEqual(obj, ref)) {
      // Check for deep equality
      var ref2 = new Set(ref);

      var _iterator4 = _createForOfIteratorHelper(obj),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var objEntry = _step4.value;

          if (ref2.delete(objEntry)) {
            continue;
          }

          var found = false;

          var _iterator5 = _createForOfIteratorHelper(ref2),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var refEntry = _step5.value;

              if (isDeepEqual(objEntry, refEntry, options, seen)) {
                ref2.delete(refEntry);
                found = true;
                break;
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          if (!found) {
            return false;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } else if (instanceType === Types.map) {
    if (obj.size !== ref.size) {
      return false;
    }

    var _iterator6 = _createForOfIteratorHelper(obj),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _step6$value = _slicedToArray(_step6.value, 2),
            key = _step6$value[0],
            value = _step6$value[1];

        if (value === undefined && !ref.has(key)) {
          return false;
        }

        if (!isDeepEqual(value, ref.get(key), options, seen)) {
          return false;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  } else if (instanceType === Types.error) {
    // Always check name and message
    if (obj.name !== ref.name || obj.message !== ref.message) {
      return false;
    }
  } // Check .valueOf()


  var valueOfObj = valueOf(obj);
  var valueOfRef = valueOf(ref);

  if ((obj !== valueOfObj || ref !== valueOfRef) && !isDeepEqual(valueOfObj, valueOfRef, options, seen)) {
    return false;
  } // Check properties


  var objKeys = keys(obj);

  if (!options.part && objKeys.length !== keys(ref).length && !options.skip) {
    return false;
  }

  var skipped = 0;

  var _iterator7 = _createForOfIteratorHelper(objKeys),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _key3 = _step7.value;

      if (options.skip && options.skip.includes(_key3)) {
        if (ref[_key3] === undefined) {
          ++skipped;
        }

        continue;
      }

      if (!hasOwnEnumerableProperty(ref, _key3)) {
        return false;
      }

      if (!isDeepEqual(obj[_key3], ref[_key3], options, seen)) {
        return false;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  if (!options.part && objKeys.length - skipped !== keys(ref).length) {
    return false;
  } // Check symbols


  if (options.symbols !== false) {
    // Defaults to true
    var objSymbols = getOwnPropertySymbols(obj);
    var refSymbols = new Set(getOwnPropertySymbols(ref));

    var _iterator8 = _createForOfIteratorHelper(objSymbols),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _key = _step8.value;

        if (!options.skip || !options.skip.includes(_key)) {
          if (hasOwnEnumerableProperty(obj, _key)) {
            if (!hasOwnEnumerableProperty(ref, _key)) {
              return false;
            }

            if (!isDeepEqual(obj[_key], ref[_key], options, seen)) {
              return false;
            }
          } else if (hasOwnEnumerableProperty(ref, _key)) {
            return false;
          }
        }

        refSymbols.delete(_key);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    var _iterator9 = _createForOfIteratorHelper(refSymbols),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _key2 = _step9.value;

        if (hasOwnEnumerableProperty(ref, _key2)) {
          return false;
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }

  return true;
};

internals.SeenEntry = /*#__PURE__*/function () {
  function _class(obj, ref) {
    _classCallCheck(this, _class);

    this.obj = obj;
    this.ref = ref;
  }

  _createClass(_class, [{
    key: "isSame",
    value: function isSame(obj, ref) {
      return this.obj === obj && this.ref === ref;
    }
  }]);

  return _class;
}();